export default __webpack_public_path__ + "static/media/Image-29.325cc5bc.png";